import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PropertyGallery = ({ images, virtualTour, videoWalkthrough }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showVirtualTour, setShowVirtualTour] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const goToImage = (index) => {
    setCurrentImageIndex(index);
  };

  return (
    <div className="relative bg-surface">
      {/* Main Gallery */}
      <div className="relative h-96 lg:h-[500px] overflow-hidden rounded-lg">
        <Image
          src={images[currentImageIndex]}
          alt={`Property view ${currentImageIndex + 1}`}
          className="w-full h-full object-cover"
        />
        
        {/* Navigation Arrows */}
        <button
          onClick={prevImage}
          className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-smooth"
          aria-label="Previous image"
        >
          <Icon name="ChevronLeft" size={20} />
        </button>
        
        <button
          onClick={nextImage}
          className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-smooth"
          aria-label="Next image"
        >
          <Icon name="ChevronRight" size={20} />
        </button>

        {/* Image Counter */}
        <div className="absolute bottom-4 left-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm">
          {currentImageIndex + 1} / {images.length}
        </div>

        {/* Action Buttons */}
        <div className="absolute bottom-4 right-4 flex space-x-2">
          <Button
            variant="secondary"
            size="sm"
            iconName="Play"
            iconPosition="left"
            onClick={() => setShowVideo(true)}
          >
            Video Tour
          </Button>
          <Button
            variant="secondary"
            size="sm"
            iconName="Eye"
            iconPosition="left"
            onClick={() => setShowVirtualTour(true)}
          >
            360° View
          </Button>
        </div>
      </div>

      {/* Thumbnail Strip */}
      <div className="mt-4 flex space-x-2 overflow-x-auto pb-2">
        {images.map((image, index) => (
          <button
            key={index}
            onClick={() => goToImage(index)}
            className={`flex-shrink-0 w-20 h-16 rounded-lg overflow-hidden border-2 transition-smooth ${
              index === currentImageIndex
                ? 'border-primary' :'border-transparent hover:border-border'
            }`}
          >
            <Image
              src={image}
              alt={`Thumbnail ${index + 1}`}
              className="w-full h-full object-cover"
            />
          </button>
        ))}
      </div>

      {/* Virtual Tour Modal */}
      {showVirtualTour && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4">
          <div className="relative w-full max-w-4xl h-96 lg:h-[500px] bg-surface rounded-lg overflow-hidden">
            <iframe
              src={virtualTour}
              className="w-full h-full"
              title="360° Virtual Tour"
              allowFullScreen
            />
            <button
              onClick={() => setShowVirtualTour(false)}
              className="absolute top-4 right-4 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-smooth"
            >
              <Icon name="X" size={20} />
            </button>
          </div>
        </div>
      )}

      {/* Video Modal */}
      {showVideo && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4">
          <div className="relative w-full max-w-4xl h-96 lg:h-[500px] bg-surface rounded-lg overflow-hidden">
            <video
              src={videoWalkthrough}
              controls
              autoPlay
              className="w-full h-full object-cover"
            />
            <button
              onClick={() => setShowVideo(false)}
              className="absolute top-4 right-4 w-10 h-10 bg-black/50 hover:bg-black/70 text-white rounded-full flex items-center justify-center transition-smooth"
            >
              <Icon name="X" size={20} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertyGallery;